import { GraduationCap } from "lucide-react";

export const Header = () => (
  <header className="bg-white border-b border-slate-200 sticky top-0 z-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3" data-testid="app-logo">
        <div className="w-11 h-11 rounded-2xl bg-blue-600 flex items-center justify-center shadow-md shadow-blue-600/25">
          <GraduationCap className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="font-heading font-extrabold text-xl text-slate-900 leading-tight">Pripremko</h1>
          <p className="text-xs text-slate-500">Pametni pomoćnik za pedagošku dokumentaciju</p>
        </div>
      </div>
    </div>
  </header>
);
